<app-page-body>

  <!-- header -->
  <app-page-header [title]="title" [isForm]="true" [loading]="loading" (onBack)="onClose()" (onRefresh)="onReset()">
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">

    <app-group-price-details-form [groupPrices]="groupPriceDetail" [readOnly]="true" [showPageHeader]="false"
      [tagName]="tagName">
      <legend legend class="tw-py-2">
        <span class="tw-font-medium">
          {{"common.organizationName"|translate}} :
        </span>
        <span class="tw-font-bold tw-mr-3 text-warning">
          {{organizationName}}
        </span>
      </legend>
    </app-group-price-details-form>

    <app-group-price-social-media-detail-form id="socialMediaDetails"
      [groupPriceDetail]="groupPriceDetail?.socialMediaDetails" [showPageHeader]="false"
      [readOnly]="true"></app-group-price-social-media-detail-form>

  </div>

</app-page-body>
